import React, {useState} from "react";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import I18n from 'i18n.js.erb'


const Faq = ({}) => {
  const faqs = I18n.t('js.faq.faqContent');
  const [expandedPanelName, setExpandedPanelName] = useState(faqs[Object.keys(faqs)[0]].name);
  const [expandedPanelTitle, setExpandedPanelTitle] = useState(faqs[Object.keys(faqs)[0]].title);
  const [expandedPanelQuestions, setExpandedPanelQuestions] = useState(faqs[Object.keys(faqs)[0]].questions);

  const handleExpand = (name, title, questions) => {
    setExpandedPanelName(name);
    setExpandedPanelTitle(title);
    setExpandedPanelQuestions(questions)
  }

  return <React.Fragment>
      <div className="row pl-3 pr-3">
        <div className="col-12 pl-4 mt-10px mb-10px">
          <h2 className="text-weight-700 mb-0">{I18n.t('js.faq.title')}</h2>
          <p className="text-weight-300">{I18n.t('js.faq.subtitle')}</p>
        </div>
      </div>
      <div className="row pl-3 pr-3 d-none d-md-flex d-lg-flex">
        <div className="col-3 w-100 pl-4" id="left-menu-faq">
          <div className="w-100 bg-white">
            <table className="table table-hover no-margins w-100">
              <tbody className="w-100">
              {
                Object.entries(faqs).map(([panel, panelContent]) => {
                  return <tr
                    className={`w-100 cursor-pointer ${expandedPanelName === panelContent['name'] ? 'text-aiBlue' : ''}`}
                    key={panelContent['name']+'_'+panel}
                    onClick={(e) => handleExpand(panelContent['name'], panelContent['title'], panelContent['questions'])}>
                    <td className="pl-3">
                      <h4 className="mb-4 d-none d-lg-flex mt-20px"> {panelContent["title"]}</h4>
                      <h6 className="mb-4 d-lg-none d-md-flex mt-20px"> {panelContent["title"]}</h6>
                    </td>
                    <td>
                      <i className="fas fa-chevron-right"/>
                    </td>
                  </tr>
                })
              }
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-9 w-100 pl-3 pr-3 pt-0">
          <div className="d-block w-100 bg-white pl-4 pr-4 pb-4 pt-3 text-space text-justify mt-0 mb-5 scrollable-div">
            <h2 className="mb-30px mt-0">{expandedPanelTitle}</h2>
            <div className="d-block">
              {
                Object.entries(expandedPanelQuestions).map(([questionNumber, questionContent], i) => {
                  return <div className="d-block mt-20px" key={questionContent['question']}>
                    <b>
                      {(i + 1).toString() + '. ' + questionContent['question']}
                    </b>
                    <p>
                      {questionContent['response']}
                    </p>
                  </div>
                })
              }
            </div>
          </div>
        </div>
      </div>

      <div className="ml-md-4 d-lg-none d-md-none d-sm-block mb-5 pr-2 pl-2">
        {
          Object.entries(faqs).map(([panel, panelContent]) => {
            return <Accordion expanded={expandedPanelName === panelContent['name']}
                              className="mt-3"
                              key={panelContent['name']}
                              onChange={(e) => handleExpand(panelContent['name'], panelContent['title'], panelContent['questions'])}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <h3 className="text-space">{panelContent['title']}</h3>
              </AccordionSummary>
              <AccordionDetails>
                <div className="d-block">
                  {
                    Object.entries(panelContent['questions']).map(([questionNumber, questionContent]) => {
                      return <div className="d-block" key={questionContent['question']}>
                        <b>
                          {questionContent['question']}
                        </b>
                        <p>
                          {questionContent['response']}
                        </p>
                      </div>
                    })
                  }
                </div>
              </AccordionDetails>
            </Accordion>
          })
        }
      </div>
  </React.Fragment>

};

export default Faq;